import { jsx as _jsx } from "react/jsx-runtime";
import Page from "../Page";
import HCPAccessLogo from "../HCPAccessLogo";
import "./PageFallback.css";
const PageFallback = () => {
    return (_jsx(Page, Object.assign({ className: "page-fallback" }, { children: _jsx(HCPAccessLogo, { theme: "gray" }) })));
};
export default PageFallback;
